import { useState } from "react";
import dscrFallback from "@/assets/hero/hero-investor-rates-home-data.jpg";
import strategyFallback from "@/assets/hero/hero-brrrr-calculator.jpg";
import foreignNationalFallback from "@/assets/hero/hero-investment-property-closing.jpg";
import sectionEightFallback from "@/assets/hero/hero-multifamily.jpg";
import marketFallback from "@/assets/hero/hero-best-rental-markets-family-research.jpg";
import companyLogo from "@/assets/simply-approved-logo-horizontal.png.asset.json";

const CATEGORY_IMAGES: Record<string, string> = {
  "dscr-loans": dscrFallback,
  "investor-strategy": strategyFallback,
  "foreign-national": foreignNationalFallback,
  "section-8": sectionEightFallback,
  "market-data": marketFallback,
};

type BlogPostImageProps = {
  src?: string | null;
  alt?: string | null;
  title: string;
  category?: string | null;
  eager?: boolean;
  className?: string;
};

export function blogFallbackImage(category?: string | null): string {
  return (category && CATEGORY_IMAGES[category]) || dscrFallback;
}

/** Keeps artwork complete while compositing only the approved company mark. */
export function BlogPostImage({
  src,
  alt,
  title,
  category,
  eager = false,
  className = "",
}: BlogPostImageProps) {
  const fallback = blogFallbackImage(category);
  const [resolvedSrc, setResolvedSrc] = useState(src || fallback);

  return (
    <span className={`relative block overflow-hidden bg-brand-dark ${className}`}>
      <img
        src={resolvedSrc}
        alt={alt?.trim() || `Investment property financing guide: ${title}`}
        width={1200}
        height={630}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
        onError={() => {
          if (resolvedSrc !== fallback) setResolvedSrc(fallback);
        }}
      />
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-brand-dark/50 via-transparent to-brand-gold/20" />
      <span className="pointer-events-none absolute inset-x-0 top-0 flex min-h-10 items-center justify-end border-b-2 border-brand-gold bg-background px-3 py-1.5 sm:min-h-12 sm:px-4">
        <img
          src={companyLogo.url}
          alt=""
          width={258}
          height={62}
          className="h-7 w-auto max-w-[48%] object-contain sm:h-8"
          aria-hidden="true"
        />
      </span>
    </span>
  );
}